module.exports = __webpack_public_path__ + "static/media/8.6fe0071a.jpg";